module.exports = __webpack_public_path__ + "assets/img/youtube_1299.472fd9b6.png";